import {Locales} from '@netx/core-next/locales/utils/Locales';

export const URL_TEXT_FIELD_ACTION_LABEL = Locales((i18n) => ({
	TEST: i18n('i18n.test'),
}));

export const URL_TEXT_FIELD_LABEL = Locales((i18n) => ({
	NAME: i18n('i18n.url'),
}));

export const URL_TEXT_FIELD_MESSAGES = Locales((i18n) => ({
	TESTING: i18n('i18n.checkingURLMessage'),
	ACCESSIBLE: i18n('i18n.urlAccessibleMessage'),
	INACCESSIBLE: i18n('i18n.urlInaccessibleMessage'),
}));
